// src/components/icons/HamburgerIcon.js
/* ------------------------------------------------------------------ */
/* HamburgerIcon – three-bar mobile menu toggle                        */
/* ------------------------------------------------------------------ */
/**
 * @param {object} props  Regular SVG props (className, onClick, …)
 * @returns {JSX.Element}
 */
export const HamburgerIcon = (props) => (
  <svg viewBox="0 0 24 24" className="h-8 w-8 fill-tertiary" {...props}>
    <path d="M3 6h18M3 12h18M3 18h18" stroke="currentColor" strokeWidth="2" />
  </svg>
);
